// Components==============
import { faBell, faBellSlash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import storeWrongAnswer from 'actions/wrongAnswer/store';
import { ClapSoundExerciseContext } from 'components/Exercises/ClapSoundExercise/ClapSoundExercise';
import { motion } from 'framer-motion';
import React, { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import useSound from 'use-sound';
import { wiggle } from 'utilities/framerAnimations';
import { BellStatus } from '../Exercise';
import './Buttons.module.scss';
// =========================

export default function Buttons({
    word,
    children,
}: {
    word?: ExerciseTypes;
    children: React.ReactNode;
}) {
    const { setCurrent, name, setAnswers, answers, current } = useContext(
        ClapSoundExerciseContext
    );

    const [wiggleStatus, setWiggleStatus] = useState<BellStatus>('initial');

    const triggerWiggle = (type: BellStatus) => {
        if (type === 'wrong') setWiggleStatus('wrong');
        if (type === 'right') setWiggleStatus('right');

        // time until wiggle stops
        setTimeout(() => setWiggleStatus('initial'), 400);
    };

    const dispatch = useDispatch();

    const { treatmentId, exerciseId } = useParams() as {
        treatmentId: string;
        exerciseId: string;
    };

    const cantClick = answers.length >= current || !word;

    const [playWrongAudio] = useSound('/audio/ring-bell/bel_kort_vals.wav');
    const [playRightAudio] = useSound('/audio/ring-bell/bel_kort_normaal.wav');
    const [playIncorrectAudio] = useSound(
        '/audio/ring-bell/bel_kort_verkeerd.wav'
    );

    function storeWrong(answer: string) {
        if (cantClick) return;

        dispatch(
            storeWrongAnswer({
                given_answer: answer,
                correct_answer: word?.name,
                type: 'woord',
                exercise_id: exerciseId,
                exercise_type: 'audio',
                treatment_id: treatmentId,
            })
        );
    }

    function handleRightClick() {
        setTimeout(() => setCurrent((prev) => prev + 1), 750);

        if (word?.correct) {
            setAnswers((prev) => [...prev, 'right']);
            setTimeout(() => {
                triggerWiggle('right');
                playRightAudio();
            }, 400);
        }

        if (!word?.correct) {
            setAnswers((prev) => [...prev, 'incorrectRight']);
            storeWrong('Verkeerd geklikt');
            setTimeout(() => playIncorrectAudio(), 150);

            setTimeout(() => {
                triggerWiggle('wrong');
                playWrongAudio();
            }, 700);
        }
    }

    function handleWrongClick() {
        setTimeout(() => setCurrent((prev) => prev + 1), 750);

        if (word?.correct) {
            setAnswers((prev) => [...prev, 'incorrectWrong']);
            storeWrong('Verkeerd geklikt');
            setTimeout(() => playIncorrectAudio(), 150);

            setTimeout(() => {
                triggerWiggle('right');
                playRightAudio();
            }, 700);
        }

        if (!word?.correct) {
            setAnswers((prev) => [...prev, 'wrong']);
            setTimeout(() => {
                triggerWiggle('wrong');
                playWrongAudio();
            }, 400);
        }
    }

    return (
        <>
            <motion.div
                styleName="right"
                initial={{ scale: 1, opacity: 0 }}
                animate={{
                    x: wiggleStatus === 'right' ? wiggle : 0,
                    scale: 1,
                    opacity: 1,
                }}
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
                onClick={handleRightClick}
                style={{ pointerEvents: cantClick ? 'none' : undefined }}
            >
                <FontAwesomeIcon icon={faBell} />
                <h1>{name}</h1>
            </motion.div>
            {children}
            <motion.div
                styleName="wrong"
                initial={{ scale: 1, opacity: 0 }}
                animate={{
                    x: wiggleStatus === 'wrong' ? wiggle : 0,
                    scale: 1,
                    opacity: 1,
                }}
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
                onClick={handleWrongClick}
                style={{ pointerEvents: cantClick ? 'none' : undefined }}
            >
                <FontAwesomeIcon icon={faBellSlash} />
                <h1>andere klank</h1>
            </motion.div>
        </>
    );
}
